<template>
    <div class="container">
        <menus></menus>
        <div class="main">
            <!-- 内容 -->
            <div class="user">
                <span>{{ $t('welcome.welcome') }}</span><span>{{ phone }}</span><span @click="signOut" style="color:#fff">{{
                    $t('welcome.signOut') }}</span>
            </div>
            <div>
                <div class="mainTitle">{{ $t('menu.meetingS') }}</div>
                <div class="mainContent mainBody">
                    <img :src="$i18n.locale == 'jp' ? 'https://oss.eventnet.cn/H5/Nissan_meeting/2024/time_en.png?v=12231805' : 'https://oss.eventnet.cn/H5/Nissan_meeting/2024/time.png?v=12231805'" alt="">
                    <!-- <p @click="path('theme', '主题分会查询')">
                        <img style="width: .58rem;"
                                src="https://oss.eventnet.cn/H5/Nissan_meeting/2022/theme.png?v=0223" alt="">
                            {{ $t('meetingS.menu1') }}
                    </p> -->
                </div>
                <p class="last" @click="path('yhquery', '工作宴会查询')">
                    <img src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/menu/16.png" alt="">
                    {{ $t('meetingS.menu2') }}
                </p>
            </div>
        </div>
        <div class="back" @click="path('menu')" :style="{ 'font-size': $i18n.locale == 'jp' ? '.2rem' : '.28rem' }">
            <img width="100%" src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/back.png" alt="">
        </div>
        <div class="toast" v-show="toastShow">
            {{ toastText }}
        </div>
    </div>
</template>
<script>
import menus from "../components/menu.vue"
export default {
    components: {
        menus
    },
    name: "menuView",
    data() {
        return {
            phone: localStorage.getItem("nissan2023_meeting_mobile"),
            name: "田鑫",
            toastShow: false,
            toastText: ""
        }
    },
    created() {
        //_hmt.push(['_trackPageview', '/meetingS']);

    },
    mounted() {
        // this.alerts3("<p style='text-align:left;'>" + this.$t('tips.tips3') + "</p>");
    },
    methods: {
        alerts3(content) {
            layer.open({
                title: [
                    this.$t('tips.tips1'),
                    'background-color: #c61533; color:#fff;'
                ],
                content: content,
                btn: this.$t('tips.tips2'),
                yes: function (index) {
                    layer.closeAll();
                }
            });
        },
        signOut() {
            localStorage.removeItem("nissan2023_meeting_uuid")
            this.$router.replace('/login');
        },
        path(path, name) {
            let that = this, data = new FormData();
            if (path == 'yhquery') {
                data.append('title', name)
                data.append('lang', that.$i18n.locale);
                data.append('uuid', localStorage.getItem("nissan2023_meeting_uuid"));
                that.axios.post('menu', data).then((res) => {
                    if (res.data.code == 200) {
                        if (res.data.type == 1) {
                            if (path == 'yhquery') {
                                this.$router.replace('/' + path + '?name=me').catch()
                                return;
                            }
                        } else {
                            that.toast(that.$t('back.waiting'));
                        }
                    } else {
                        that.toast(res.data.msg);
                    }
                }).catch(err => err);
            } else {
                this.$router.replace('/' + path)
            }
        },
        toast(str) {
            let that = this
            that.toastText = str
            that.toastShow = true
            setTimeout(function () {
                that.toastShow = false
            }, 1500)
        },
    }
}
</script>
<style scoped>
.mainContent {
    min-height: 4rem;
    width: 6rem;
    margin: 0 auto .27rem;
    color: #fff;
    font-size: .29rem;
    font-weight: 600;
    padding: .2rem .3rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;


}

.mainContent img {
    width: 5.3rem;
    display: block;
}

.last {
    width: 6rem;
    padding-bottom: .1rem;
    height: 1.3rem;
    background: url(https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/menu/menu_bg1.png) no-repeat;
    justify-content: center;
    padding-left: 0;
    background-size: 100%;
    height: 1.3rem;
    padding-bottom: .1rem;
    display: flex;
    align-items: center;
    font-size: .3rem;
    margin: 0 auto;
    font-weight: bold;

}

.last>img {
    width: 0.75rem;
    margin-right: .35rem;
}
</style>


// WEBPACK FOOTER //
// src/views/meetingS.vue